import React, { FC, useState, useEffect } from 'react';
import { Steps } from 'antd-mobile';
import { MTools } from '@/components';
import { getMediaList } from "@/services/service";
import styles from './index.less';
import arrowBlue from '@/assets/image/arrowBlue.png';
import stepIocn from '@/assets/image/stepIocn.png';

const { Step } = Steps;

interface ComProps {
  showBorderBottom?: boolean;
  title?: string;
  style?: React.CSSProperties;
}

interface ListItemType {
  id: string;
  title: string;
  time: string;
  [key: string]: any;
}

const ThemeDayNews: FC<ComProps> = ({
  style,
  title = '主题日新闻',
  showBorderBottom = false,
}) => {
  const [list, setList] = useState<ListItemType[]>([]);

  useEffect(() => {
    getList();
  }, []);

  const getList = async () => {
    const _result = await getMediaList({
      columnType: 'theme',
    });
    if (_result.success) {
      const _list = (_result.data || []).filter((i: any) => i.status === 1);
      const _temList = _list.length > 5 ? _list.slice(0, 5) : _list;
      setList(_temList);
    } else {
      MTools.Tips('error', '系统异常，请刷新再试');
    }
  }

  const handleNewItemClick = (_item: ListItemType) => {
    MTools.Url.gotoUrl(`/app/newsDetail/${_item.id}?type=media`);
  }

  const handleToList = () => {
    MTools.Url.gotoUrl(`/app/newsList/2`);
  }

  return (
    <div className={styles.newsWrapper} style={style}>
      <div className={styles.titleW}>
        <div className={styles.newsTitle} onClick={handleToList}>
          <span>{title}</span>
          <img src={arrowBlue} alt="" />
        </div>
      </div>

      <Steps direction='vertical'>
        {
          list.map((item: ListItemType) => (
            <Step
              key={item.id}
              icon={(
                <img src={stepIocn} className={styles.stepIcon} />
              )}
              title={(
                <div className={styles.stepTitle} onClick={() => handleNewItemClick(item)}>{item.title}</div>
              )}
            />
          ))
        }
      </Steps>

      {
        showBorderBottom && (
          <div className={styles.bottomLine}></div>
        )
      }
    </div>
  );
};

export default ThemeDayNews;
